import React, { useEffect } from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import { showCorrespondence } from "../../../services/insurance/correspondence"
import { getAppointmentDate, getAppointmentTime, timeConvert } from "../../../services/insurance/common";
import CircularProgress from '@mui/material/CircularProgress';
import { useAxiosLoader } from '../../../plugins/axios'
import moment from 'moment';

export default function ShowCorrespondenceDialog(props) {
    const [loading] = useAxiosLoader();
    const [details] = React.useState(props.details);
    const [correspondence, setCorrespondence] = React.useState([]);

    useEffect(() => {
        let isMounted = true;
        if(isMounted){
            showCorrespondence(details.id).then(res => {
                res && res.correspondences && res.correspondences.map(ele=>{ele.createdOn= moment(ele.createdOn)})
                setCorrespondence(res.correspondences)
            })
            console.log("details", details)
        }
        return () => { isMounted = false };
    }, [details])


    return (
        <div>
            {loading ?
                <div className="m-auto text-center pt-4">
                    <CircularProgress />
                </div> :
                <Timeline position="alternate">
                    {
                        correspondence && correspondence.length > 0 ? correspondence.map((elem, index) => (

                            <TimelineItem>
                                <TimelineOppositeContent color="text.secondary">
                                    <div className="text-sm">
                                        {getAppointmentDate(elem.createdOn)} {getAppointmentTime(elem.createdOn)}
                                    </div>
                                </TimelineOppositeContent>
                                <TimelineSeparator>
                                    <TimelineDot variant="outlined" color={index === 0 ? "success" : 'primary'} />
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent>
                                    <div className={(index % 2 === 1) ? "corr-card-design-2 rounded-lg shadow-lg  px-6 py-4" : "corr-card-design-1 rounded-lg shadow-lg  px-6 py-4"}>
                                        <div className="font-semibold">
                                            {elem.callStatusValue}
                                        </div>
                                        {
                                            elem.rC_Blob &&  JSON.parse(elem.rC_Blob).uicnumber?
                                                <div className="text-sm">
                                                    <span> UIC Number : </span>
                                                    {JSON.parse(elem.rC_Blob).uicnumber}
                                                </div>
                                                : <></>
                                        }

                                        {
                                            elem.comment ?
                                                <div className="text-sm">
                                                    <span> Comments : </span>
                                                    {elem.comment}
                                                </div>
                                                : <></>
                                        }

                                        {
                                            elem.rC_Blob && JSON.parse(elem.rC_Blob).callbackdate ?
                                                <div className="text-sm">
                                                    <span> Call Back Date : </span>
                                                    <span className="font-semibold">
                                                    {new Date(JSON.parse(elem.rC_Blob).callbackdate).toDateString()} {timeConvert(new Date(JSON.parse(elem.rC_Blob).callbackdate).toLocaleTimeString())}
                                                    </span>
                                                </div> : <></>

                                        }

                                    </div>
                                </TimelineContent>
                            </TimelineItem>


                        )) : <div className="text-center font-semibold text-gray-600 pt-2">
                        <span className="bg-red-100 rounded p-2">
                            Correspondence is not available
                        </span>
                    </div>
                    }

                </Timeline>
            }
        </div>
    );
}